// extracted by mini-css-extract-plugin
export default {"pricesContainer":"ServicePriceItem_pricesContainer__EVuow"};